export default __webpack_public_path__ + "static/media/4t.15a87f09.jpg";